<template>
  <div class="con_bg">
    <div>
      <header>
        <el-image :src="iconHeader"></el-image>
        <p class="title_font" @click="goBack()">{{ titleName }}</p>
      </header>
      <div class="title_line"></div>
      <body>
        <div v-show="isShowList">
          <ul>
            <li
              v-for="(item, ad) in newsInfo.newsList"
              :key="ad"
              style="list-style: none"
            >
              <div class="news_bg">
                <el-image :src="item.mnHhimg" class="item_img_bg t-h"
                  ><div slot="error">
                    <el-image :src="defaultImg"> </el-image></div
                ></el-image>
                <div @click="checkItem(item)">
                  <p class="t-h">{{ item.mnTitle }}</p>
                  <span>
                    {{ item.mnDigest }}
                  </span>
                </div>
              </div>
              <div class="line_two"></div>
            </li>
          </ul>
          <div style="text-align: center; margin-top: 8px">
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size="pageParams.pageSize"
              layout="prev, pager, next"
              :total="newsInfo.total"
            >
            </el-pagination>
          </div>
        </div>
        <div class="ql-editor" v-show="isShowContent" v-html="htmlInfo"></div>
      </body>
    </div>
  </div>
</template>

<script>
import { getNewsDetail, setBrowerecord } from "@/network/api";
export default {
  data() {
    return {
      defaultImg: require("@/assets/images/defalut_icon.png"),
      iconHeader: require("@/assets/images/pageico_2.png"),
      isShowContent: false,
      isShowList: true,
      htmlInfo: "",
      titleName: "新闻动态",
      newsInfo: {
        newsList: [],
        total: 0,
      },
      pageParams: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    checkItem(item) {
      setBrowerecord('news', item.id)
      this.htmlInfo = item.mnContent;
      this.isShowContent = true;
      this.isShowList = false;
      this.titleName = "新闻动态 | " + item.mnTitle + " |【返回】";
    },
    goBack() {
      this.isShowContent = false;
      this.isShowList = true;
      this.titleName = "新闻动态";
    },
    initData: function () {
      getNewsDetail(this.pageParams).then((res) => {
        console.log(res);
        this.newsInfo.newsList = res.rows;
        this.newsInfo.total = res.total;
      });
    },
    handleCurrentChange(val) {
      this.pageParams.pageNum = val;
      this.initData();
    },
  },
};
</script>


<style scoped>
ul,
li {
  margin: 0;
  padding: 0;
}
.con_bg {
  display: flex;
  justify-content: center;
}
header {
  width: 1150px;
  display: flex;
  margin-bottom: 6px;
  align-items: center;
}
body {
  width: 1150px;
  margin-top: 12px;
  margin-bottom: 12px;
}
.news_bg {
  display: flex;
  margin-top: 12px;
}
.news_bg p {
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
  margin-left: 12px;
}
.news_bg span {
  font-size: 16px;
  color: #909090;
  margin-left: 12px;
}
.title_line {
  padding: 0;
  height: 1px;
  background-color: #b7b7b7;
}
.title_font {
  color: #397b3e;
  font-size: 20px;
  margin-left: 6px;
  cursor: pointer;
}
.line_two {
  border-bottom: 1px dashed #e2e2e2;
  margin-top: 12px;
}
.item_img_bg {
  width: 264px;
  height: 174px;
  flex-shrink: 0;
  margin-right: 12px;
}
.t-h:hover {
  cursor: pointer;
  color: #397b3e;
}
</style>


// WEBPACK FOOTER //
// src/components/newsSta.vue